// source: ErrorCode.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.Billon.ErrorCode.ErrorCode', null, global);
/**
 * @enum {number}
 */
proto.Billon.ErrorCode.ErrorCode = {
  UNDEFINED: 0,
  OK: 1,
  REJECTED: 2
};

goog.object.extend(exports, proto.Billon.ErrorCode);
